(function () {
  'use strict';

  if (!window.djiCareMap || Object.keys(window.djiCareMap).length === 0) return;

  var I18N = window.djiCareI18n || {};
  var cartAddUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add.js';

  var modalRoot = null;
  var currentCare = null;
  var selectedVariantId = null;
  var inFlight = false;
  var allCareVariantIds = collectCareVariantIds();

  function collectCareVariantIds() {
    var ids = [];
    Object.keys(window.djiCareMap).forEach(function (droneId) {
      (window.djiCareMap[droneId].variants || []).forEach(function (v) { ids.push(v.id); });
    });
    return ids;
  }

  function isAddToCartUrl(url) {
    if (typeof url !== 'string') return false;
    return url.indexOf('/cart/add') !== -1;
  }

  function interceptFetch() {
    if (!window.fetch) return;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = isAddToCartUrl(url);
      var promise = origFetch.apply(this, arguments);
      if (!isAdd) return promise;
      return promise.then(function (response) {
        if (response && response.ok) {
          response.clone().json().then(handleCartAddResponse).catch(noop);
        }
        return response;
      });
    };
  }

  function interceptXHR() {
    var XHR = window.XMLHttpRequest;
    if (!XHR) return;
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this._djiCareUrl = url;
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function () {
      var xhr = this;
      if (isAddToCartUrl(xhr._djiCareUrl)) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            try { handleCartAddResponse(JSON.parse(xhr.responseText)); } catch (e) {}
          }
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function handleCartAddResponse(data) {
    if (!data) return;
    var items = data.items ? data.items : (data.product_id ? [data] : []);
    if (items.length === 0) return;

    for (var j = 0; j < items.length; j++) {
      if (allCareVariantIds.indexOf(items[j].variant_id) !== -1) return;
    }

    for (var i = 0; i < items.length; i++) {
      var productId = items[i].product_id;
      var careData = window.djiCareMap[productId];
      if (!careData) continue;
      if (isDismissed(productId)) continue;

      checkCareNotInCart(careData, function (notInCart) {
        if (notInCart) {
          setTimeout(function () { openModal(productId, careData); }, 400);
        }
      });
      return;
    }
  }

  function checkCareNotInCart(careData, callback) {
    var careVariantIds = careData.variants.map(function (v) { return v.id; });
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var found = (cart.items || []).some(function (it) {
          return careVariantIds.indexOf(it.variant_id) !== -1;
        });
        callback(!found);
      })
      .catch(function () { callback(true); });
  }

  function dismissKey(productId) { return 'djiCareUpsellDismissed_' + productId; }
  function isDismissed(productId) {
    try { return sessionStorage.getItem(dismissKey(productId)) === '1'; }
    catch (e) { return false; }
  }
  function setDismissed(productId) {
    try { sessionStorage.setItem(dismissKey(productId), '1'); } catch (e) {}
  }

  function openModal(productId, careData) {
    var availableVariants = careData.variants.filter(function (v) {
      return v.available && v.price > 0;
    });
    if (availableVariants.length === 0) return;

    currentCare = { productId: productId, data: careData };

    var kind = careData.kind === 'camera' ? 'camera' : 'drone';
    var L = (I18N[kind] || I18N.drone || {});
    var C = (I18N.common || {});

    var imgEl = modalRoot.querySelector('.dji-care-modal__image');
    if (careData.image) { imgEl.src = careData.image; imgEl.alt = careData.title || ''; }
    modalRoot.querySelector('.dji-care-modal__title').textContent = L.title || '';
    modalRoot.querySelector('.dji-care-modal__intro').textContent = L.intro || '';

    var benefits = modalRoot.querySelectorAll('.dji-care-modal__benefit');
    if (benefits[0]) benefits[0].textContent = L.benefit1 || '';
    if (benefits[1]) benefits[1].textContent = L.benefit2 || '';
    if (benefits[2]) benefits[2].textContent = L.benefit3 || '';

    var learnMore = modalRoot.querySelector('.dji-care-modal__learn-more');
    if (learnMore) {
      if (careData.url) {
        learnMore.href = careData.url;
        learnMore.textContent = C.learnMore || 'Read more';
        learnMore.style.display = '';
      } else {
        learnMore.style.display = 'none';
      }
    }

    var variantsRoot = modalRoot.querySelector('.dji-care-modal__variants');
    variantsRoot.innerHTML = '';
    availableVariants.forEach(function (v, idx) {
      var inputId = 'dji-care-variant-' + v.id;
      var label = document.createElement('label');
      label.className = 'dji-care-modal__variant';
      label.htmlFor = inputId;
      label.innerHTML =
        '<input type="radio" name="djiCareVariant" id="' + inputId + '" value="' + v.id + '"' + (idx === 0 ? ' checked' : '') + '>' +
        '<span class="dji-care-modal__variant-title">' + escapeHtml(v.title) + '</span>' +
        '<span class="dji-care-modal__variant-price">' + escapeHtml(v.priceFormatted) + '</span>';
      variantsRoot.appendChild(label);
    });
    selectedVariantId = availableVariants[0].id;

    var addBtn = modalRoot.querySelector('.dji-care-modal__add');
    addBtn.textContent = C.add || 'Add';
    addBtn.disabled = false;
    inFlight = false;
    modalRoot.querySelector('.dji-care-modal__skip').textContent = C.skip || 'Skip';

    modalRoot.hidden = false;
    modalRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dji-care-modal-open');

    setTimeout(function () {
      var closeBtn = modalRoot.querySelector('.dji-care-modal__close');
      if (closeBtn) closeBtn.focus();
    }, 50);

    document.addEventListener('keydown', onEsc);
  }

  function closeModal(opts) {
    opts = opts || {};
    if (!modalRoot) return;
    if (currentCare && opts.dismiss) setDismissed(currentCare.productId);
    modalRoot.hidden = true;
    modalRoot.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dji-care-modal-open');
    document.removeEventListener('keydown', onEsc);
    currentCare = null;
    selectedVariantId = null;
  }

  function onEsc(e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeModal({ dismiss: true });
  }

  function bindClose() {
    modalRoot.addEventListener('click', function (e) {
      var node = e.target;
      while (node && node !== modalRoot) {
        if (node.hasAttribute && node.hasAttribute('data-dji-care-close')) {
          closeModal({ dismiss: true });
          return;
        }
        node = node.parentNode;
      }
    });
    modalRoot.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'djiCareVariant') {
        selectedVariantId = parseInt(e.target.value, 10);
      }
    });
  }

  function bindAdd() {
    var addBtn = modalRoot.querySelector('[data-dji-care-add]');
    addBtn.addEventListener('click', function () {
      if (inFlight || !selectedVariantId) return;
      inFlight = true;
      addBtn.textContent = (I18N.common && I18N.common.adding) || 'Adding...';
      addBtn.disabled = true;

      var formData = new FormData();
      formData.append('id', selectedVariantId);
      formData.append('quantity', 1);

      fetch(cartAddUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { scrollToTop: false }
          }));
          closeModal();
        })
        .catch(function () {
          inFlight = false;
          addBtn.textContent = (I18N.common && I18N.common.add) || 'Add';
          addBtn.disabled = false;
        });
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function noop() {}

  function init() {
    modalRoot = document.getElementById('dji-care-upsell-modal');
    if (!modalRoot) return;
    bindClose();
    bindAdd();
    interceptFetch();
    interceptXHR();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
